/**
 * Auth utility functions for dynamic Auth0 role namespace handling
 * Supports environment-specific namespaces (staging vs production)
 */

/**
 * Get the Auth0 role namespace for current environment
 * @returns {string} The namespace URL for roles
 */
export const getAuthNamespace = () => {
  // Use environment-specific namespace or fallback to production
  return process.env.VUE_APP_AUTH0_ROLES_NAMESPACE || 'https://readysetspray.com/roles'
}

/**
 * Extract user roles from Auth0 user object using correct namespace
 * @param {Object} user - Auth0 user object
 * @returns {Array} Array of role strings
 */
export const getUserRoles = (user) => {
  if (!user) return []
  
  const namespace = getAuthNamespace()
  return user[namespace] || []
}

/**
 * Check if user has any of the specified roles
 * @param {Object} user - Auth0 user object
 * @param {Array|string} roles - Role(s) to check for
 * @returns {boolean} True if user has any of the specified roles
 */
export const hasRole = (user, roles) => {
  const userRoles = getUserRoles(user)
  const checkRoles = Array.isArray(roles) ? roles : [roles]
  
  return checkRoles.some(role => userRoles.includes(role))
}

/**
 * Check if user has technician role
 * @param {Object} user - Auth0 user object
 * @returns {boolean} True if user has technician role
 */
export const hasTechnicianRole = (user) => {
  return hasRole(user, 'technician')
}

/**
 * Get primary role for display purposes
 * @param {Object} user - Auth0 user object
 * @returns {string} Primary role or 'Technician' as fallback
 */
export const getPrimaryRole = (user) => {
  const roles = getUserRoles(user)
  return roles[0] || 'Technician'
}